import React, { Component } from 'react';

import Select from '@components/Select';
import { SAVE_PROFILE } from '@redux/form/types';
import { CHANGE_LANGUAGE } from '@redux/translates/types';
import numeral from 'numeral';
import { connect } from 'react-redux';
import * as S from './styles';

class SelectLanguage extends Component {
  state = {};

  handleLanguage = (language) => {
    const {
      props: {
        dispatch,
        authenticationReducer: { dataUser },
      },
    } = this;
    let data = {};
    numeral.locale(language);
    dispatch({
      type: CHANGE_LANGUAGE.SUCCESS,
      language,
      changedByUser: true,
    });

    data = {
      language,
      user_name: dataUser.user_name,
      user_last_name: dataUser.user_last_name,
    };
    dispatch({
      type: SAVE_PROFILE.REQUEST,
      version: '1.0',
      data,
    });
  };

  render() {
    const {
      props: {
        translatorReducer: { language },
      },
    } = this;

    const values = [
      {
        language: 'pt-BR',
        label: 'Português (BR)',
      },
      {
        language: 'en-US',
        label: 'English (US)',
      },
      {
        language: 'es-ES',
        label: 'Español',
      },
    ];

    return (
      <Select onChange={(e) => this.handleLanguage(e.target.value)} selectValue={language}>
        {values.map((value, index) => (
          <S.OptionStyled key={index} value={value.language}>
            {value.label}
          </S.OptionStyled>
        ))}
      </Select>
    );
  }
}

function mapStateToProps(state) {
  return {
    translatorReducer: state.translatorReducer,
    authenticationReducer: state.authenticationReducer,
    formReducer: state.formReducer,
  };
}

export default connect(mapStateToProps)(SelectLanguage);
